const testimonials = [
  {
    name: 'Ahmet Yılmaz',
    role: 'Genel Müdür, Savunma Teknolojileri A.Ş.',
    avatar: 'https://public.readdy.ai/ai/img_res/62c221d49afe36bf27bcfd1e948fd21f.jpg',
    rating: 5,
    title: 'Profesyonel ve Hızlı Süreç',
    text: 'MSB Tesis Güvenlik Belgesi alma sürecinde aldığımız danışmanlık hizmeti beklentilerimizin çok üzerinde çıktı. Tüm evraklar eksiksiz hazırlandı ve süreç tahmin ettiğimizden çok daha hızlı tamamlandı. Savunma sanayi projelerine katılım için kritik olan bu belgeyi zamanında aldık.'
  },
  {
    name: 'Zeynep Kaya',
    role: 'Güvenlik Müdürü, Havacılık Sistemleri Ltd.',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Turkish%20female%20security%20manager%20in%20her%2040s%20with%20dark%20hair%20wearing%20white%20blouse%2C%20clean%20white%20background%2C%20corporate%20photography%20style%2C%20professional%20demeanor%2C%20aviation%20industry%20executive%2C%20high-end%20professional%20photo&width=200&height=200&seq=avatar-tr-002&orientation=squarish',
    rating: 5,
    title: 'Mevzuata Tam Hakimiyet',
    text: 'Fiziki güvenlik altyapımızın kurulumundan personel güvenlik soruşturmalarına kadar her aşamada detaylı rehberlik aldık. 5188 sayılı kanun ve yönetmeliklere tam hakimiyetleri sayesinde hiçbir eksik yaşamadan NATO Tesis Güvenlik Belgemizi aldık. Kesinlikle tavsiye ediyorum.'
  },
  {
    name: 'Mehmet Demir',
    role: 'Kurucu Ortak, Elektronik Savunma Sistemleri',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Turkish%20male%20entrepreneur%20in%20his%2040s%20with%20black%20hair%20wearing%20gray%20suit%2C%20clean%20white%20background%2C%20corporate%20photography%20style%2C%20warm%20smile%2C%20defense%20electronics%20founder%2C%20high-end%20professional%20photo&width=200&height=200&seq=avatar-tr-003&orientation=squarish',
    rating: 5,
    title: 'Güvenilir Danışmanlık',
    text: 'Yeni kurduğumuz firmamız için Milli Tesis Güvenlik Belgesi başvuru sürecinde yanımızda oldular. CCTV, alarm ve erişim kontrol sistemlerinin kurulumunda teknik destek sağladılar. Belgemizi ilk başvuruda aldık. Çok memnun kaldık.'
  },
  {
    name: 'Ayşe Şahin',
    role: 'İdari İşler Müdürü, Optik Sistemler A.Ş.',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Turkish%20female%20administrative%20manager%20in%20her%2030s%20with%20long%20dark%20hair%20wearing%20navy%20blazer%2C%20clean%20white%20background%2C%20corporate%20photography%20style%2C%20confident%20smile%2C%20optical%20systems%20executive%2C%20high-end%20professional%20photo&width=200&height=200&seq=avatar-tr-004&orientation=squarish',
    rating: 5,
    title: 'Belge Yenileme Kolaylığı',
    text: 'Tesis Güvenlik Belgemizin süre uzatma işlemlerinde aldığımız hizmet mükemmeldi. Tüm güncellemeleri takip ettiler, gerekli evrakları zamanında hazırladılar. Belge yenileme sürecimiz hiçbir aksaklık yaşanmadan tamamlandı. Teşekkür ederiz.'
  },
  {
    name: 'Can Özdemir',
    role: 'Operasyon Müdürü, Füze Sistemleri Ltd.',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Turkish%20male%20operations%20manager%20in%20his%2040s%20with%20short%20black%20hair%20wearing%20charcoal%20suit%2C%20clean%20white%20background%2C%20corporate%20photography%20style%2C%20serious%20expression%2C%20missile%20systems%20executive%2C%20high-end%20professional%20photo&width=200&height=200&seq=avatar-tr-005&orientation=squarish',
    rating: 5,
    title: 'Uçtan Uca Destek',
    text: 'MSB denetimlerine hazırlık sürecinde aldığımız danışmanlık sayesinde tüm kontrol noktalarını eksiksiz tamamladık. Personel eğitimlerinden dokümantasyon süreçlerine kadar her konuda profesyonel destek aldık. Denetimi başarıyla geçtik.'
  },
  {
    name: 'Elif Arslan',
    role: 'Kalite Güvence Müdürü, Radar Teknolojileri',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Turkish%20female%20quality%20manager%20in%20her%2030s%20with%20brown%20hair%20wearing%20teal%20blazer%2C%20clean%20white%20background%2C%20corporate%20photography%20style%2C%20professional%20smile%2C%20radar%20technology%20executive%2C%20high-end%20professional%20photo&width=200&height=200&seq=avatar-tr-006&orientation=squarish',
    rating: 5,
    title: 'Detaylı ve Titiz Çalışma',
    text: 'Özel Tesis Güvenlik Belgesi başvurumuzda gösterdikleri titizlik ve detaycılık takdire şayan. Her dokümanı en ince ayrıntısına kadar kontrol ettiler. Gizlilik dereceli bilgi yönetimi konusunda aldığımız eğitimler çok faydalı oldu. Kesinlikle öneriyoruz.'
  }
];

export default function Testimonials() {
  return (
    <section id="testimonials" className="py-24 px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="mb-16">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-2 h-2 bg-orange-500 rounded-full"></div>
            <p className="text-orange-500 text-sm font-semibold uppercase tracking-wider">
              Müşteri Görüşleri
            </p>
          </div>
          <h2 className="font-serif text-5xl font-bold text-gray-900 leading-tight">
            Referanslarımız
            <br />
            ve Başarı Hikayelerimiz
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-lg p-8 border border-gray-200 hover:shadow-lg transition-shadow flex flex-col"
            >
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-orange-500 text-lg"></i>
                ))}
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{testimonial.title}</h3>
              <p className="text-gray-600 leading-relaxed mb-6 flex-grow" style={{ lineHeight: '1.6' }}>
                {testimonial.text}
              </p>
              <div className="flex items-center gap-4 pt-4 border-t border-gray-200 mt-auto">
                <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={testimonial.avatar}
                    alt={testimonial.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <div className="font-bold text-gray-900">{testimonial.name}</div>
                  <div className="text-sm text-gray-500">{testimonial.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
